namespace Core {

    class PayLater {

        message: string;
        total: number;
        enabled: boolean = false;
        area: string;
        validAreas = {
            Holidays: 'holidays',
            Hotels: 'hotels'
        };
        overrideEnabled: boolean;

        constructor(private $scope: ng.IScope, private analytics, private modalService, private $route){

            if( this.overrideEnabled ){
                this.enabled = true;
            } else {
                const total = this.$scope.$watch('pl.total', value => {
                    if( value ){
                        this.enabled = this.getEnabled();
                        total();
                    }
                });
                const area = this.$scope.$watch('pl.area', value => {
                    if (value) {
                        this.enabled = this.getEnabled();
                        area();
                    }
                });
            }
        }

        getEnabled() {
            const area = this.area || this.$route.current.area;
            return (area.toLowerCase() === this.validAreas.Holidays || area.toLowerCase() === this.validAreas.Hotels)
            && TRPCONFIG.Domain.BuyNowPayLaterEnabled && this.total > TRPCONFIG.Domain.BuyNowPayLaterCost;
        }

        showPayLaterModal() {
            this.analytics.track('mixpanel', 'PayLaterModal');
            this.modalService.launch('partials/popups/paylater');
        }
    }

    angular
        .module('core')
        .directive('payLater', ($filter): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: true,
                bindToController: {
                    message: '@',
                    total: '@',
                    viewType: '@',
                    area : '@',
                    overrideEnabled : '='
                },
                controller: PayLater,
                controllerAs: 'pl',
                template: (elem, attrs) => {
                    if (attrs.viewType === 'link') {
                        return `<div class="hype-message" ng-show="pl.enabled">
                        <a class="hype-message hype-message-pay-later" href="offers/zero-interest-payment-plan" 
                        target= "_blank">{{ pl.message }}</a>
                        </div>`;
                    } else if( attrs.viewType === 'banner') {
                        return `<div class="pay-later-block" ng-show="pl.enabled">
                        <img class="pay-later-banner"/>
                        </div>`;
                    } else if ( attrs.viewType === 'block') {
                        return `<div class="pay-later-block" ng-show="pl.enabled">
                        <div class="pay-later-img"></div>
                        <div class="pay-later-desc">
                            <p ng-bind-html="pl.message"></p>
                        </div>
                        </div>`;
                    }
                    return `<div class="hype-message hype-message-pay-later hype-message-has-popup"
                    ng-show="pl.enabled" ng-click="pl.showPayLaterModal()">
                    {{ pl.message }}<i class="icon-information"></i>
                    </div>`;
                }
            };
        });

}
